import {useEffect} from 'react';
import { useRoutes } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setUserData } from '../redux/actions/ActionsUserData';
import MyStorage from '../store/MyStorage';

// routes
import MainRoutes from './MainRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';


// ==============================|| ROUTING RENDER ||============================== //

function ThemeRoutes() {
    const dispatch = useDispatch();
    const {user } = useSelector((state) => state.user_data);
    
    const checkLogin = () => {
        new MyStorage().getUserInfo().then(u => {
            if (u) {
                u = JSON.parse(u);
                dispatch(setUserData(u));
            } else {
            }
        });
    }
    useEffect(() => {
        checkLogin();
    },[]);
  // , config.basename
  return useRoutes([ user  ? MainRoutes : AuthenticationRoutes]);
}

export default ThemeRoutes;
